import { render, staticRenderFns } from "./switchButton.vue?vue&type=template&id=468ad1b8"
import script from "./switchButton.vue?vue&type=script&lang=js"
export * from "./switchButton.vue?vue&type=script&lang=js"
import style0 from "./switchButton.vue?vue&type=style&index=0&id=468ad1b8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports